// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__kr4O-","inheritColor":"Icon_inheritColor__Ce5GO","clickable":"Icon_clickable__XUfPn"};